import React from 'react';
import PropTypes from 'prop-types';

const UploadValidationErrors = ({helperText}) => {
  if (!helperText) return null;

  return (
    <div
      style={{
        marginTop: '20px',
        marginBottom: '10px',
        padding: '18px',
        background: 'transparent',
        border: '1px solid #e11d48',
        borderRadius: '8px',
        width: '100%',
        boxSizing: 'border-box'
      }}>
      <div
        style={{
          fontSize: '12px',
          lineHeight: '1.6',
          color: '#444',
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
        }}>
        {typeof helperText === 'string'
          ? helperText.split('\n').map((line, idx) => {
              if (line.includes('Invalid Store IDs detected')) {
                const parts = line.split(/(\d+)/);
                return (
                  <div
                    key={idx}
                    style={{
                      fontWeight: '400',
                      fontSize: '12px',
                      marginBottom: '12px',
                      color: '#999'
                    }}>
                    {parts.map((part, i) =>
                      /^\d+$/.test(part) ? (
                        <span
                          key={i}
                          style={{
                            display: 'inline-block',
                            fontWeight: '700',
                            fontSize: '16px',
                            background: '#e11d48',
                            color: 'white',
                            padding: '2px 10px',
                            borderRadius: '6px',
                            margin: '0 3px'
                          }}>
                          {part}
                        </span>
                      ) : (
                        part
                      )
                    )}
                  </div>
                );
              }
              if (line.startsWith('•')) {
                return (
                  <div
                    key={idx}
                    style={{
                      fontFamily: 'Menlo, Monaco, "Courier New", monospace',
                      fontWeight: '600',
                      fontSize: '12px',
                      padding: '6px 12px',
                      margin: '5px 0',
                      background: 'rgba(225, 29, 72, 0.06)',
                      color: '#e11d48',
                      borderRadius: '6px',
                      letterSpacing: '0.3px'
                    }}>
                    {line}
                  </div>
                );
              }
              if (line.includes('Store IDs must be numeric')) {
                return (
                  <div
                    key={idx}
                    style={{
                      fontSize: '10px',
                      marginTop: '12px',
                      color: '#999',
                      lineHeight: '1.5'
                    }}>
                    {line}
                  </div>
                );
              }
              return <div key={idx}>{line || '\u00A0'}</div>;
            })
          : helperText}
      </div>
    </div>
  );
};

UploadValidationErrors.propTypes = {
  helperText: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
};

export default React.memo(UploadValidationErrors);
